import { AppAbility } from "../../shared/abilities/ability";
import { CustomerFilterViewMoel } from "../model/CustomerFilterViewModel";
import * as CustomerAPI from "../services/CustomerAPI";
import * as constant from '../../shared/util/constant';

class CutomerMainPortalHeaderService {
    getCustomerSummary = async (customerId) : Promise<CustomerFilterViewMoel> => {
        let customerData = await CustomerAPI.getCustomerSummary(customerId);
        return customerData;
    }

    getSliderTabToActivate = (ability : AppAbility) : string => {

        if (ability.can('create',"Customer Activity",constant.ScreenName.CUSTOMER_ACTIVITY)) {
            return constant.CustomerScreenTabs.activity.key;
        }

        if (ability.can('view',"Customer", constant.ScreenName.CUSTOMER) 
            && ability.can('read',"Customer", constant.ScreenName.CUSTOMER)) {
            return constant.CustomerScreenTabs.contacts.key;
        }

        if (ability.can('create', 'Customer Memo' ,constant.CustomerScreenName.CUSTOMER_NOTES)) {
            return constant.CustomerScreenTabs.notes.key;
        }

        if (ability.can('create',"Customer Task",constant.ScreenName.CUSTOMER_TASK)) {
            return constant.CustomerScreenTabs.tasks.key;
        }

        return null;
    }
};

export default  CutomerMainPortalHeaderService;